import { defineComponent as a, computed as o, openBlock as c, createElementBlock as i, createElementVNode as t, toDisplayString as d, createCommentVNode as _, normalizeStyle as f } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "574025dc-5e21-4528-8b02-e07c3d6f141e" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#574025dc-5e21-4528-8b02-e07c3d6f141e)" }, k = { key: 0 }, p = /* @__PURE__ */ t("path", {
  fill: "#eee",
  d: "m0 256 258.2-43.3L512 256v256H0z"
}, null, -1), v = /* @__PURE__ */ t("path", {
  fill: "#d80027",
  d: "M0 0h512v256H0z"
}, null, -1), g = { fill: "none" }, x = ["r"], B = /* @__PURE__ */ a({
  __name: "mc",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, l = o(() => 512 + 2 * e.strokeWidth), s = o(() => -e.strokeWidth), n = o(() => 256 + e.strokeWidth / 2);
    return (w, y) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", u, [
        e.flagName ? (c(), i("title", k, d(e.flagName), 1)) : _("", !0),
        p,
        v
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=mc-7b29124b.js.map
